import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'number-7', 'Number7', [["path",{"d":"M8 4h8l-4 16"}]]);